import React, { Component } from 'react';
import EdiText from 'react-editext';
import '../../content/css/EditableTextArea.css';

export default class EditableTextArea extends Component {
    constructor(props) {
        super(props);

        this.state = {
            text: props.text
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        var self = this;
        if (prevProps.text !== this.props.text) this.setState({ text: self.props.text });
    }

    handleSave = val => {
        this.setState({ text: val });
        this.props.onChange(val);
    }

    render() {
        return (
            <EdiText
                showButtonsOnHover
                editButtonClassName="editable-text-field-btn"
                viewContainerClassName='my-custom-view-wrapper'
                type='textarea'
                inputProps={{
                    rows: 5
                }}
                saveButtonContent='Save'
                cancelButtonContent={<strong>Cancel</strong>}
                value={this.state.text}
                onSave={this.handleSave}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CategoryView/EditableTextArea.js